module.exports = __webpack_public_path__ + "img/sendinblue.80c72fae.png";